import { Box, Flex, Loader } from '@mantine/core';

import { useChartsAuth, useRetrieveCharts } from '@hooks/chart';
import classes from './MongoDashboard.module.css';
import { MongoDashboardChart } from './MongoDashboardChart';

export const ChartsTab = () => {
  const { data: chartsList, isLoading: isChartsLoading } = useRetrieveCharts();
  const { data: chartAuth, isLoading: isTokenLoading } = useChartsAuth();
  const token = chartAuth?.token;
  const chartsBaseUrl = chartAuth?.chartsBaseUrl;

  return (
    <Box className={classes.container}>
      {(isChartsLoading || isTokenLoading) && (
        <Flex className={classes.loadingAndNoDataContainer}>
          <Loader />
        </Flex>
      )}
      {!isChartsLoading && !isTokenLoading && (
        <>
          {!!chartsList?.length && (
            <Box className={classes.list}>
              {chartsList?.map((chart) => (
                <MongoDashboardChart key={chart.name + chart.order} token={token} chart={chart} chartsBaseUrl={chartsBaseUrl} />
              ))}
            </Box>
          )}
          {!chartsList?.length && (
            <Flex className={classes.loadingAndNoDataContainer}>
              <div>No data found</div>
            </Flex>
          )}
        </>
      )}
    </Box>
  );
};
